module.exports = __webpack_public_path__ + "2d0260b2287fc4489e1beb163d9a9d41.png";